import {
  ADD_CATEGORY,
  ADD_CATEGORY_ERROR,
  ADD_CATEGORY_SUCCESS,
  GET_CATEGORIES,
  GET_CATEGORIES_ERROR,
  GET_CATEGORIES_SELECT_LIST_SUCCESS,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORY,
  GET_CATEGORY_ERROR,
  GET_CATEGORY_SUCCESS,
  TOGGLE_CATEGORY_MODAL,
  UPDATE_CATEGORY,
  UPDATE_CATEGORY_ERROR,
  UPDATE_CATEGORY_SUCCESS,
  UPLOAD_CATEGORY_ICON,
  UPLOAD_CATEGORY_ICON_ERROR,
  UPLOAD_CATEGORY_ICON_SUCCESS,
} from "./actionTypes";

const initialState = {
  // categories
  loadingCategories: false,
  loadingCategoriesSuccess: false,
  loadingCategoriesError: null,
  categories: {},
  // add category
  category: {},
  addCategoryLoading: false,
  addCategoryError: null,
  addCategorySuccess: false,
  // get category
  getCategoryLoading: false,
  getCategoryError: null,
  getCategorySuccess: null,
  // update category
  updateCategoryLoading: false,
  updateCategoryError: null,
  updateCategorySuccess: false,
  // icon
  uploadingCategoryIcon: false,
  uploadCategoryIconSuccess: null,
  uploadCategoryIconError: null,
  // select list
  categoriesSelectList: [],
};

const categories = (state = initialState, action) => {
  switch (action.type) {
    case GET_CATEGORIES:
      state = {
        ...state,
        updateCategorySuccess: false,
        addCategorySuccess: false,
        loadingCategoriesError: null,
        loadingCategoriesSuccess: false,
        loadingCategories: true,
        categories: [],
        category: {},
      };
      break;
    case GET_CATEGORIES_SUCCESS:
      state = {
        ...state,
        loadingCategories: false,
        loadingCategoriesSuccess: true,
        loadingCategoriesError: null,
        categories: action.payload,
      };
      break;
    case GET_CATEGORIES_ERROR:
      state = {
        ...state,
        loadingCategories: false,
        loadingCategoriesError: action.payload,
        loadingCategoriesSuccess: false,
        categories: [],
      };
      break;
    case TOGGLE_CATEGORY_MODAL:
      state = {
        ...state,
        category: {},
      };
      break;
    case ADD_CATEGORY:
      state = {
        ...state,
        addCategoryLoading: true,
        addCategoryError: null,
        addCategorySuccess: false,
      };
      break;
    case ADD_CATEGORY_SUCCESS:
      state = {
        ...state,
        addCategoryLoading: false,
        addCategoryError: null,
        addCategorySuccess: true,
        category: {},
      };
      break;
    case ADD_CATEGORY_ERROR:
      state = {
        ...state,
        addCategoryLoading: false,
        addCategoryError: action.payload,
        addCategorySuccess: false,
      };
      break;
    case GET_CATEGORY:
      state = {
        ...state,
        category: {},
        getCategoryLoading: true,
        getCategoryError: null,
        getCategorySuccess: false,
      };
      break;
    case GET_CATEGORY_SUCCESS:
      state = {
        ...state,
        category: action.payload,
        getCategoryLoading: false,
        getCategoryError: null,
        getCategorySuccess: true,
      };
      break;
    case GET_CATEGORY_ERROR:
      state = {
        ...state,
        getCategoryError: action.payload,
        getCategoryLoading: false,
        getCategorySuccess: false,
      };
      break;
    case UPDATE_CATEGORY:
      state = {
        ...state,
        updateCategoryLoading: true,
        updateCategoryError: null,
        updateCategorySuccess: false,
      };
      break;
    case UPDATE_CATEGORY_SUCCESS:
      state = {
        ...state,
        updateCategoryLoading: false,
        updateCategoryError: null,
        updateCategorySuccess: true,
      };
      break;
    case UPDATE_CATEGORY_ERROR:
      state = {
        ...state,
        updateCategoryLoading: false,
        updateCategoryError: action.payload,
        updateCategorySuccess: false,
      };
      break;
    case UPLOAD_CATEGORY_ICON:
      state = {
        ...state,
        uploadingCategoryIcon: true,
      };
      break;
    case UPLOAD_CATEGORY_ICON_SUCCESS:
      state = {
        ...state,
        uploadingCategoryIcon: false,
        category: { ...state.category, icon: action.payload },
      };
      break;
    case UPLOAD_CATEGORY_ICON_ERROR:
      state = {
        ...state,
        uploadingCategoryIcon: false,
        uploadCategoryIconError: action.payload,
      };
      break;
    case GET_CATEGORIES_SELECT_LIST_SUCCESS:
      state = {
        ...state,
        categoriesSelectList: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default categories;
